























import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobUserStatusEnum } from '@/types/jobUserStatus';
import { getStatusName } from '@/services/jobService';
import moment from 'moment';

@Component({})
export default class JobStatusHistoryItem extends Vue {
  @Prop({ type: String, default: "" }) public at!: string;
  @Prop({ type: Number, default: 0 }) public offset!: number;
  @Prop({ type: Number, default: JobUserStatusEnum.START_CONTINUE_WORK }) public statusId!: number;
  @Prop({ type: String, default: "" }) public comment!: string;
  @Prop({ type: Boolean, default: false }) public isAutomatic!: boolean;

  get statusName(){
    let name = getStatusName(this.statusId);

    if(this.isAutomatic){
      name += " (Automatic)";
    }

    return name;
  }

  get atTime(){
    if (this.offset) {
      return moment(this.at).utcOffset(this.offset).format("HH:mm");
    }
    
    return moment(this.at).format("HH:mm");
  }

  get canSwapToEditMode(){
    if(this.statusId === JobUserStatusEnum.FINISH_WORK || this.isAutomatic) {
      return false;
    }

    return true;
  }

  swapToEditMode(){
    if(!this.canSwapToEditMode) {
      return;
    }

    this.$emit("edit");
  }
}

